import { render, staticRenderFns } from "./PriceInputs.vue?vue&type=template&id=98c68dfa&scoped=true&"
import script from "./PriceInputs.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceInputs.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceInputs.vue?vue&type=style&index=0&id=98c68dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c68dfa",
  null
  
)

export default component.exports